<template>
  <div id="DmhSelect" class="border-brand-primary">
    <button
      class="dmh-option border-brand-primary clickable"
      v-for="(option, i) in question.options"
      @click="selectOptionIndex(i, option.option_text)"
      :key="i"
    >
      <div class="dmh-option-icon brand-primary mr-4">
        <i :class="getClass(option.option_text)"></i>
      </div>
      <div class="dmh-option-text brand-text">{{ option.option_text }}</div>
    </button>
  </div>
</template>

<script>
export default {
  name: "DmhStart",
  props: ["question", "answer", "setAnswer", "answerQuestion"],
  methods: {
    selectOptionIndex(i, optionText = "") {
      this.setAnswer(i);
      if (optionText.includes("I'd like to learn more about the service")) {
        this.$router.push("/learn-more");
      } else {
        this.answerQuestion();
      }
    },
    getClass(text) {
      switch (text) {
        case "I'd like to talk to someone about my mental health.":
          return "fa-solid fa-head-side-virus";
        case "I'd like to learn more about the service.":
          return "fa-solid fa-book-open-reader";
        case "Financial Information":
          return "fa-solid fa-balance-scale";
        case "Legal Information":
          return "fa-solid fa-book-open-reader";
        case "I'd like to learn more about mental health and Wellbeing.":
          return "fa-solid fa-heart-pulse";
        case "I'd like to get access another service like financial or legal.":
          return "fa-solid fa-coins";
        default:
          return "";
      }
    }
  },
};
</script>
<style lang="less">
#DmhSelect {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 650px;
  width: 100%;

  .dmh-option {
    background-color: white;
    max-width: 800px;
    width: 100%;
    display: flex;
    flex-grow: 1;
    flex-direction: row;
    align-items: center;
    padding: 24px;
    border-radius: 20px;
    margin-bottom: 30px;
    border: 2px solid #aeb0bd;
    text-align: left;

    .dmh-option-text {
      font-family: "PlusJakartaSansBold";
      font-size: 1.6rem;
      width: 100%;
    }

    .brand-primary {
      .fa-solid {
        color: inherit !important;
      }
    }

    .fa-solid {
      font-size: 4rem;
      color: lightgrey;
    }

    .fa-regular {
      font-size: 4rem;
      color: lightgrey;
    }
  }
}
</style>
